module.exports = __webpack_public_path__ + "img/cloud2.45cb8694.svg";